import { IRootState } from '../reducer'

export const newsfeedData = (state: IRootState) => state.newsfeed.newsfeedData
export const newsfeedItem = (state: IRootState) => state.newsfeed.newsfeedItem
export const headlineReplies = (state: IRootState) => state.newsfeed.headlineReplies
export const clientNewsfeedData = (state: IRootState) => state.newsfeed.clientNewsfeedData
export const wrongMatchReport = (state: IRootState) => state.newsfeed.wrongMatchReport
